import { Box, Flex } from "@chakra-ui/react";
import { NavLink, type NavLinkProps, useMatch } from "react-router-dom";
import { type ReactNode, useState } from "react";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";

type FoldableSidebarLinkProps = {
	icon: ReactNode;
	label: string;
};

function FoldableSidebarLinkFoldIcon({
	fold,
	onFold,
}: {
	fold: boolean;
	onFold?: (fold: boolean) => void;
}) {
	const handleFold = () => {
		if (onFold) {
			onFold(!fold);
		}
	};

	if (fold) {
		return <ChevronDownIcon h="21px" onClick={handleFold}></ChevronDownIcon>;
	}
	return <ChevronRightIcon h="21px" onClick={handleFold}></ChevronRightIcon>;
}

function FoldableSidebarLink({
	children,
	icon,
	label,
	to,
	...rest
}: NavLinkProps & FoldableSidebarLinkProps) {
	const isActive = useMatch(to.toString());
	const [fold, setFold] = useState(false);

	if (isActive) {
		return (
			<>
				<Flex
					bg="white"
					rounded="lg"
					px="6px"
					py="8px"
					boxShadow="sm"
					color="brand.700"
					fontWeight="600"
					fontSize="14px"
					lineHeight="21px"
				>
					<NavLink to={to} {...rest} style={{ width: "100%" }}>
						<Flex align="center" gap="2">
							<>
								{icon} {label}
							</>
						</Flex>
					</NavLink>
					<FoldableSidebarLinkFoldIcon
						fold={fold}
						onFold={setFold}
					></FoldableSidebarLinkFoldIcon>
				</Flex>
				<Box
					opacity={fold ? "0" : "1"}
					transition="opacity 0.5s ease-out"
					h={fold ? 0 : "auto"}
					overflow={fold ? "hidden" : undefined}
				>
					<>{children}</>
				</Box>
			</>
		);
	}
	return (
		<>
			<Flex
				px="6px"
				py="8px"
				color="gray.700"
				fontWeight="600"
				fontSize="14px"
				lineHeight="21px"
			>
				<NavLink to={to} {...rest} style={{ width: "100%" }}>
					<Flex align="center" gap="2">
						<>
							{icon} {label}
						</>
					</Flex>
				</NavLink>
				<FoldableSidebarLinkFoldIcon
					fold={fold}
					onFold={setFold}
				></FoldableSidebarLinkFoldIcon>
			</Flex>
			<Box
				opacity={fold ? "0" : "1"}
				transition="opacity 0.5s ease-out"
				h={fold ? 0 : "auto"}
				overflow={fold ? "hidden" : undefined}
			>
				<>{children}</>
			</Box>
		</>
	);
}

export default FoldableSidebarLink;
